module.exports = __webpack_public_path__ + "img/icon-16-time.b55f776d.svg";